// ─────────────────────────────────────────────────────────────────
// FeatureOverview — the "what AdaptOS offers" card beneath MemoryHero.
// Four clickable features that jump to the relevant dashboard view.
// Copy is authored by the team — kept verbatim.
// ─────────────────────────────────────────────────────────────────

const FEATURES = [
  {
    nav: 'career_hub',
    icon: '🧭',
    title: 'Career Hub',
    body: 'Find out what role makes sense for you and add it to your roadmap to know what certifications make you a qualified candidate.',
  },
  {
    nav: 'roadmap',
    icon: '🗺️',
    title: 'Roadmap',
    body: 'Uses input from Career Hub to design the right path to the career of your choice.',
  },
  {
    nav: 'assessments',
    icon: '⏩',
    title: 'Fast Track',
    body: "Don't waste time learning things you already understand, take a test to find out if you can skip that lesson.",
  },
  {
    nav: 'certifications',
    icon: '📜',
    title: 'Certification Paths',
    body: 'Your one-stop shop for all the certifications AdaptOS offers. We update and upload certifications every week.',
  },
];

export default function FeatureOverview({ onNavigate }) {
  return (
    <div style={{ maxWidth: 760, margin: '20px auto 0' }}>
      <p style={{ fontSize: 11, fontWeight: 800, letterSpacing: 0.6, textTransform: 'uppercase', color: 'var(--brand-slate)', margin: '0 0 12px 4px' }}>
        What AdaptOS offers
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 12 }}>
        {FEATURES.map(f => (
          <button
            key={f.nav}
            type="button"
            onClick={() => onNavigate?.(f.nav)}
            style={{
              textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit',
              background: '#ffffff', border: '1px solid #eef0f4', borderRadius: 16,
              padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 6,
              boxShadow: 'var(--card-shadow)', transition: 'border-color 0.15s, transform 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(217,119,6,0.35)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#eef0f4'; e.currentTarget.style.transform = 'none'; }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
              <span aria-hidden style={{ fontSize: 18, lineHeight: 1 }}>{f.icon}</span>
              <span style={{ fontSize: 15, fontWeight: 800, color: '#1e1e2e' }}>{f.title}</span>
              <span aria-hidden style={{ marginLeft: 'auto', color: 'var(--brand-amber)', fontWeight: 700 }}>→</span>
            </span>
            <span style={{ fontSize: 12.5, color: 'var(--brand-slate)', lineHeight: 1.5 }}>{f.body}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
